import { useTranslation } from "react-i18next";
import type { FC, ChangeEvent } from "react";

import { SelectStyled } from "./LanguageSelect.styles";
import { LOCALES } from "../../constants/locales";

const FLAG_BY_LOCALE = {
  [LOCALES.en]: "🇬🇧",
  [LOCALES.pl]: "🇵🇱",
};

const getSelectOptions = () =>
  Object.entries(LOCALES).map(([key, value]) => (
    <option key={key} value={key}>{`${FLAG_BY_LOCALE[value] || ""} ${value.toUpperCase()}`}</option>
  ));

const LanguageSelect: FC = () => {
  const { i18n } = useTranslation();

  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    i18n.changeLanguage(event.target.value);
  };

  return (
    <SelectStyled onChange={handleChange} value={i18n.language}>
      {getSelectOptions()}
    </SelectStyled>
  );
};

export default LanguageSelect;
